import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateProjectComponent } from './create-project/create-project.component';
import { StepperFormsComponent } from './stepper-forms/stepper-forms.component';
import { ContentComponent } from './layouts/content/content.component';
import { QuoteMyProjectComponent } from './quote-my-project/quote-my-project.component';
import { WarningComponent } from './warning/warning.component';
import { EQuotationComponent } from './e-quotation/e-quotation.component';

const routes: Routes = [
  {
    path: '',
    component: ContentComponent,
    children: [
      {
        path: 'create-project',
        title: 'Create New Quote',
        component: CreateProjectComponent,
      },
      {
        path: ':type/create-project',
        title: 'Create New Quote for Type',
        component: CreateProjectComponent,
      },
      {
        path: ':type/stepper-forms',
        title: 'Manufacturing-Quote',
        component: StepperFormsComponent,
      },
      {
        path: '',
        title: 'Get-Quote',
        component: QuoteMyProjectComponent,
      },
      {
        path: 'warning',
        component: WarningComponent,
      },
      {
        path: 'e-quotation',
        title:'Engineering-Quote',
        component: EQuotationComponent
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuotingToolRoutingModule { }
